export default __webpack_public_path__ + "static/media/caffeine_free.0474c664.jpeg";